module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'menu/vertical-accordeon' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": "shortTitle",
	"depthLevel": 3,
	"expandable": true,
	"closable": true,
	"autoClose": false,
	"higlightOnlyCurrent": false,
	"hidePreviousListOnExpand": false
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/menu/vertical-accordeon/config.yaml
// module id = 113
// module chunks = 0